const ASSOCIATION_COLUMNS = [
  {
    Header: 'Camp Name',
    accessor: 'CampName',
    className: 'notranslate ymca-word-break ymca-text-primary'
  },
  {
    Header: 'Association Name',
    accessor: 'AssociationName',
    className: 'notranslate'
  },
  {
    Header: 'Y Type',
    accessor: 'YType',
    className: 'notranslate'
  },
  {
    Header: 'Member Group',
    accessor: 'MemberGroup',
    className: 'notranslate'
  },
  {
    Header: 'Overall Status',
    accessor: 'Status',
    className: 'notranslate statusShow'
  },
  {
    Header: 'Last Updated Date Time',
    accessor: 'UpdatedDateTime',
    className: 'notranslate text-center'
  },
  {
    Header: '',
    accessor: 'detailsLink'
  }
];

export default ASSOCIATION_COLUMNS;
